import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import Text from '../../Text';
import { CourseCardCta, CoursesWrapper, UserSettings } from './style';
import Checkbox from '../../Checkbox';
import CustomSelect from '../../CustomSelect';
import TimeIntervalFilter from '../../TimeIntervalFilter';
import {
  COURSE_CREATED_LIST_GET,
  COURSE_CREATED_LIST_RESET,
  SAVE_PRINT_SETTINGS,
  STATS_USER_LIST,
} from '../../../../app/redux/actions/statistics';
import { getFilterLabel, getFilterOptions } from '../../../../utils/labels';
import { EXPORT_TABS } from '.';
import CustomInput from '../../CustomInput';
import NoResult from '../../NoResult';
import CTA from '../../CTA';

const UsersTab = ({
  printSettings,
  filters,
  courseList,
  getUsers,
  savePrintSettings,
  getCourseCreatedList,
  resetCourseCreated,
}) => {
  const { selectedCourse } = printSettings;
  const [exportTypes, setExportTypes] = useState(['users_list']);
  const [searchValue, setSearchValue] = useState('');
  const [selectedFilters, setSelectedFilters] = useState({
    filters_only: true,
  });

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
    savePrintSettings({
      key,
      value: value?.value,
    });
    if (key === 'ffoo' || key === 'regions') getUsers(newFilters);
  };

  const handleCheckbox = (key) => {
    const newTypes = [...exportTypes];
    const index = newTypes.findIndex((type) => type === key);
    if (index < 0) {
      if (newTypes.length === 2) newTypes.splice(1, 1);
      newTypes.push(key);
    } else {
      newTypes.splice(1, 1);
    }
    toggleSelectedCourse();
    setExportTypes(newTypes);
  };

  useEffect(() => {
    savePrintSettings({
      key: 'export_types',
      value: exportTypes,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportTypes]);

  const isMandatory = (key) => {
    if (key === 'ffoo') return 'mandatory';
    //if (key === 'group_ids' && exportTypes.length > 1) return 'mandatory';
    return '';
  };

  // course search
  const debounceSearch = debounce((v) => {
    setSearchValue(v);
    getCourseCreatedList({
      search_text: v,
      items_per_page: 20,
    });
  }, 300);
  const toggleSelectedCourse = (item) => {
    savePrintSettings({
      key: 'selectedCourse',
      value: item,
    });
    setSearchValue('');
    resetCourseCreated();
  };

  return (
    <UserSettings>
      <Text type="h2" mb={8}>
        Utenti
      </Text>
      <Text type="b3" mb={24}>
        Da questa sezione puoi scaricare la lista di utenti che hanno visibilità
        sui percorsi formativi di cui sei tutor.
      </Text>
      <fieldset>
        <Text type="b3" mb={16} tag="legend">
          Seleziona cosa includere nell’export (al massimo una scelta):
        </Text>
        <div className="checkbox-wrapper d-flex">
          <Checkbox
            label="Includi dettaglio percorso formativo"
            onChange={() => handleCheckbox('users_courses')}
            checked={exportTypes.includes('users_courses')}
          />
          <Checkbox
            label="Includi dettaglio attività"
            onChange={() => handleCheckbox('users_activities')}
            checked={exportTypes.includes('users_activities')}
          />
        </div>
        {exportTypes.includes('users_activities') && (
          <div
            className="d-flex"
            style={{
              minHeight: 80,
              marginTop: 16,
              paddingRight: 8,
              alignItems: 'end',
            }}
          >
            <div>
              <label>
                <span className="mandatory">Seleziona un corso</span>
                <CustomInput
                  size="l"
                  placeholder="Cosa vuoi cercare?..."
                  isSearch
                  value={searchValue}
                  icon="search-sm"
                  isClearable
                  onChange={(v) => {
                    if (v?.length > 2) {
                      debounceSearch(v);
                    } else setSearchValue();
                  }}
                />
              </label>
              {/* Course results */}
              {searchValue && (
                <CoursesWrapper>
                  <div className="courses-container has-scrollbar">
                    {courseList?.length > 0 ? (
                      <>
                        {courseList.map((item, i) => (
                          <div className="course-card" key={`card-${i}`}>
                            <Text type="b4" className="info">
                              {item?.code}
                              {item?.typology && (
                                <span> | {item?.typology}</span>
                              )}
                              {item?.category && (
                                <span> | {item?.category}</span>
                              )}
                            </Text>
                            <Text
                              type="h3"
                              className="ellipsis"
                              onClick={() => toggleSelectedCourse(item)}
                            >
                              {item?.title}
                            </Text>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div style={{ marginTop: '30px' }}>
                        <NoResult />
                      </div>
                    )}
                  </div>
                </CoursesWrapper>
              )}
            </div>
            {selectedCourse && (
              <CourseCardCta style={{ marginBottom: 0 }}>
                <Text type="b3" className="code">
                  {selectedCourse?.code}
                </Text>
                <div className="ellipsis">
                  {selectedCourse?.typology && (
                    <Text type="b4" className="typology">
                      {selectedCourse?.typology === 'event'
                        ? 'Evento'
                        : 'Corso'}
                    </Text>
                  )}
                  <Text type="h3" className="ellipsis">
                    {selectedCourse?.title}
                  </Text>
                </div>
                <CTA
                  type="tertiary"
                  bottomRight
                  btnText="Rimuovi"
                  icon="x"
                  onClick={() => toggleSelectedCourse()}
                />
              </CourseCardCta>
            )}
          </div>
        )}
      </fieldset>
      <div className="user-settings">
        <Text type="h3" mb={8}>
          Impostazioni
        </Text>
        <Text type="b3" mb={32}>
          Per procedere con l’export, seleziona i filtri in base alle tue
          esigenze.
        </Text>
        <div className="select-grid">
          {(Object.keys(filters) || []).map((key, i) => (
            <div key={`filter-${i}`}>
              <Text type="h3" mb={16} className={isMandatory(key)}>
                {getFilterLabel(key)}
              </Text>
              <CustomSelect
                size="s"
                wrapperId={`filter-${key}`}
                placeholder={getFilterLabel(key)}
                options={getFilterOptions(filters, key)}
                onChange={(value) => handleOnChange({ key, value })}
                isClearable
              />
            </div>
          ))}
          <div style={{ width: '200px' }}>
            <Text type="h3" mb={16}>
              Ultimo accesso
            </Text>
            <TimeIntervalFilter
              id="filter-time-interval-modal-users-tab"
              forceSplitMonths
              callback={(start_date, end_date) => {
                savePrintSettings({
                  key: 'start_date',
                  value: start_date,
                });
                savePrintSettings({
                  key: 'end_date',
                  value: end_date,
                });
              }}
              forcePosition="top right"
            />
          </div>
        </div>
      </div>
    </UserSettings>
  );
};

UsersTab.propTypes = {
  printSettings: PropTypes.object,
  filters: PropTypes.object,
  courseList: PropTypes.array,
  getUsers: PropTypes.func,
  savePrintSettings: PropTypes.func,
  getCourseCreatedList: PropTypes.func,
  resetCourseCreated: PropTypes.func,
};

export default connect(
  (state) => {
    const { list: courseList } = state.statistics.course.createdCourses;
    const { users: printSettings } = state.statistics.printSettings;
    const { filters } = state.statistics.users;
    return { printSettings, filters, courseList };
  },
  (dispatch) => ({
    savePrintSettings: ({ key, value }) =>
      dispatch({
        type: SAVE_PRINT_SETTINGS,
        key,
        value,
        tab: EXPORT_TABS.USERS,
      }),
    getUsers: (filters) =>
      dispatch({ type: STATS_USER_LIST._REQUEST, filters }),
    getCourseCreatedList: (filters) =>
      dispatch({ type: COURSE_CREATED_LIST_GET._REQUEST, filters }),
    resetCourseCreated: () => dispatch({ type: COURSE_CREATED_LIST_RESET }),
  })
)(UsersTab);
